// DS: C25P
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import MobileNativeDropdown from '../../MobileNativeDropdown';
import { updateSelectionByValue } from '../../helpers';
import FormDropdown from '../FormDropdown';
import s from './NumbersDropdown.scss';
const NumbersDropdown = (_param)=>{
    var { menuClassName, menuLabelClassName, itemClassName, items, forceNativeDropdown } = _param, props = _object_without_properties(_param, [
        "menuClassName",
        "menuLabelClassName",
        "itemClassName",
        "items",
        "forceNativeDropdown"
    ]);
    const isMobile = useContext(MobileContext);
    const placeholder = typeof props.placeholder === 'string' ? props.placeholder : '';
    const itemsWithSelection = updateSelectionByValue(props.selectedValue, items);
    // There'll only ever be one of these, so pull the last selected value
    const mobileTitle = itemsWithSelection.filter((item)=>'selected' in item && item.selected).reduce((accumulator, selection)=>selection.label, null) || placeholder;
    return isMobile || forceNativeDropdown ? /*#__PURE__*/ React.createElement(MobileNativeDropdown, _object_spread({
        isLegacyFormInput: true,
        className: s['toggle'],
        title: mobileTitle,
        titleClassName: menuLabelClassName,
        items: itemsWithSelection
    }, props)) : /*#__PURE__*/ React.createElement(FormDropdown, _object_spread({
        withScrollableArrows: true,
        withMenuPaddings: false,
        items: itemsWithSelection
    }, props));
};
NumbersDropdown.displayName = 'NumbersDropdown';
export default NumbersDropdown;

//# sourceMappingURL=NumbersDropdown.js.map